import Pages from "layouts/Pages.jsx";
import RTL from "layouts/RTL.jsx";
import Dashboard from "layouts/Dashboard.jsx";
import Logout from "layouts/Logout.jsx";
import ERTL from "layouts/ERTL.jsx";

var indexRoutes = [
  { path: "/rtl", name: "RTL", component: RTL },
  { path: "/pages", name: "Pages", component: Pages },
  { path: "/logout", name: "Logout", component: Logout},
  { path: "/review", name: 'ERTL', component: ERTL },
  { path: "/", name: "Home", component: Dashboard },
];

export default indexRoutes;
